import Vue from 'vue'
import Vuex from 'vuex'
import http from './http';
import { baseApiUrl } from './config';
import * as Sentry from '@sentry/browser';

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  state: {
    user: {},
    loading: 0,
    breadcrumbs: [],
    currentRequest: null,
  },
  mutations: {
    'SET_LOOKUPS': (state, lookupData) => {
      // eslint-disable-next-line no-console
      console.log('SET_LOOKUPS::state:', state);

      if (!lookupData || !state) return;

      console.log('lookupData:', lookupData);
      lookupData.reduce((prev, curr) => {
        prev[curr.lookupType] = ['<Empty>', ...Object.keys(curr.values).map((k) => curr.values[k])];
        state[curr.lookupType] = prev[curr.lookupType];
        return prev;
      }, {});

      // eslint-disable-next-line no-console
      console.log('returning SET_LOOKUPS::state:', state);
      return state;
    },
    'SET_VENDORS': (state, vendors) => {
      Vue.set(state, 'vendors', vendors);
    },
    'SET_USER': (state, user) => {
      // eslint-disable-next-line no-console
      console.log('SET_USER::state:', state, 'user:', user);
      if (!state || !user) return;

      state.user = user;
      // eslint-disable-next-line no-console
      console.log('returning SET_USER::state:', state);
      return state;
    },
    'SET_SEARCH_RESULTS': (state, searchResults) => {
      // eslint-disable-next-line no-console
      console.log('SET_SEARCH_RESULTS::state:', state, searchResults);

      if (!state || !searchResults) return;

      Vue.set(state, 'requestSearchResults', searchResults);
    },
    'SET_SEARCH_PRICING': (state, searchResults) => {
      console.log('SET_SEARCH_PRICING::state:', state, searchResults);

      if (!state || !searchResults) return;

      Vue.set(state, 'pricingSearchResults', searchResults);
    },
    'START_LOADING': state => state.loading++,
    'FINISH_LOADING': state => state.loading--,
    'SET_BREADCRUMBS': (state, crumbs) => Vue.set(state, 'breadcrumbs', crumbs),
    'SET_REQUEST': (state, request) => state.currentRequest = request,
    'UPDATE_REQUEST_LINE': (state, changes) => {
      const lineIndex = state.currentRequest.requestLines.findIndex(rl => rl.requestLineId === changes.requestLineId);
      const newLine = Object.assign({}, state.currentRequest.requestLines[lineIndex], changes.changes);
      state.currentRequest.requestLines[lineIndex] = newLine;
      Vue.set(state, 'currentRequest', state.currentRequest);

      console.log('changed state for updated request line:', changes);
    },
    'LOAD_PART_NUMBERS': (state, partNumbers) => {
      if (!state || !partNumbers) return;
      partNumbers.sort();
      Vue.set(state, 'partNumbers', partNumbers);
    },
    'SIGNED_IN': (state, isSignedIn) => {
      state.isSignedIn = isSignedIn;
    },
  },
  actions: {
    'SIGNED_IN': (context, isSignedIn) => {
      context.commit('SIGNED_IN', isSignedIn);
    },
    'GET_LOOKUPS': async (context) => {
      const lookupDataResponse = await http.get(`${baseApiUrl}/lookup-data`);
      const lookupData = lookupDataResponse.data;

      console.log('lookupData:', lookupDataResponse, context);
      context.commit('SET_LOOKUPS', lookupData);

      console.log('fetching vendors...');
      const vendors = await http.get(`${baseApiUrl}/vendors`);
      context.commit('SET_VENDORS', vendors.data);
    },
    'SET_USER': (context, user) => {
      // eslint-disable-next-line no-console
      console.log('calling SET_USER:', user)
      context.commit('SET_USER', user)
    },
    'SEARCH_REQUESTS': async (context, searchRequest = 'All') => {
      // eslint-disable-next-line no-console
      console.log('search requests called:', searchRequest);
      const searchResponse = await http.get(`${baseApiUrl}/search/request/status/${searchRequest}`);
      // eslint-disable-next-line no-console
      //console.log('searchResponse:', searchResponse);
      try {
        const searchResults = await searchResponse.data;

        //console.log('searchResults:', searchResults);
        context.commit('SET_SEARCH_RESULTS', searchResults);
      } catch (err) {
        Sentry.captureException(err);
        console.log('it blow-did-up:', err);
      }
    },
    'SEARCH_PRICING': async (context, searchRequest) => {
      console.log('search requests called:', context, searchRequest);
      const searchResponse = await http.get(`${baseApiUrl}/requests/pricing`);
      //console.log('searchResponse:', searchResponse);
      try {
        const searchResults = await searchResponse.data;

        //console.log('searchRequest:', searchRequest, 'searchResults:', searchResults);
        context.commit('SET_SEARCH_PRICING', searchResults);
      } catch (err) {
        Sentry.captureException(err);
        console.log('it blow-did-up:', err);
      }

    },
    'GET_REQUEST': async (context, requestId) => {
      const resp = await http.get(`${baseApiUrl}/request/${requestId}`);
      console.log('GET_REQUEST response:', resp);
      context.commit('SET_REQUEST', resp.data);
    },
    'LOAD_PART_NUMBERS': async (context) => {
      const resp = await http.get(`${baseApiUrl}/search/part-number`);
      context.commit('LOAD_PART_NUMBERS', resp.data);
    },
    'SAVE-REQUEST': async (context, request) => {
      try {
        const resp = await http.post(`${baseApiUrl}/request`, request);

        console.log('response from save request post:', resp);
        context.dispatch('SEARCH_REQUESTS');
      } catch(err) {
        console.log('Error saving request:', err, request);
        Sentry.captureException(err);
      }

    }
  }
})
